export function convertHexToRGBA(
    hexColor: string,
    alpha: number
): string | undefined {
    const hexRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

    if (!hexRegex.test(hexColor)) return;

    const hexArray = hexColor.slice(1, 7).match(/.{1,2}/g);

    if (!hexArray) return;

    const RGBValues = hexArray.map((el) => parseInt(el, 16)).join(', ');

    return `rgba(${RGBValues}, ${alpha.toString()})`;
}
